import { OfflinePossibleFilterOptionsParams } from '../types/offlineFilterOptions.types';

export const hasOfflineParams = (
  catalogId: OfflinePossibleFilterOptionsParams['catalogId'],
  basedOnList: OfflinePossibleFilterOptionsParams['basedOnList'],
): catalogId is string => {
  return !!catalogId && basedOnList === 'catalogProducts';
};
